export const getDataBackupList = state => {
    return state.list
}


// WEBPACK FOOTER //
// ./src/store/modules/dataBackup/getters.js